(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rental-quote"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.rental-quote').forEach(root => {
    const form = root.querySelector('form');
    const field = key => root.querySelector(`[data-rq="${key}"]`);
    const money = n => '$' + n.toLocaleString('en-US', { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 });
    const quantity = key => Number(field(key).value) || 0;
    const parseDate = value => value ? new Date(value + 'T12:00:00') : null;
    const dateString = date => [date.getFullYear(), String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0')].join('-');
    const pickupLocations = { nyc: 'Long Island City, NY', bay: 'San Jose, CA', la: 'North Hollywood, CA', toronto: 'Woodbridge, ON' };
    const adjacentWeekday = (date, direction) => {
      const result = new Date(date);
      do { result.setDate(result.getDate() + direction); } while ([0, 6].includes(result.getDay()));
      return dateString(result);
    };
    let deliveryEdited = false, collectionEdited = false;
    field('delivery').addEventListener('change', () => { deliveryEdited = true; update(); });
    field('collection').addEventListener('change', () => { collectionEdited = true; update(); });
    field('event').addEventListener('change', () => {
      const event = parseDate(field('event').value);
      if (event && !deliveryEdited) field('delivery').value = adjacentWeekday(event, -1);
      if (event && !collectionEdited) field('collection').value = adjacentWeekday(event, 1);
      update();
    });
    const today = new Date();
    field('event').min = dateString(today);
    function update() {
      const market = field('market').value;
      const pickupLocation = pickupLocations[market];
      const u = quantity('universal'), a = market === 'nyc' ? quantity('aromatic') : 0, e = market === 'la' ? quantity('expression') : 0, stems = u + a + e;
      const pickup = field('transport').value === 'pickup';
      const transportFee = pickup ? 50 : 300;
      const before = field('before').value, after = field('after').value;
      const beforeCost = stems * (before === 'polish' ? 3 : before === 'wash' ? 1.5 : 0);
      const afterCost = stems * (after === 'wash' ? 1.5 : 0);
      const beforeHandling = before !== 'self' ? 150 : 0;
      const afterHandling = after !== 'self' ? 150 : 0;
      const handling = beforeHandling + afterHandling;
      const total = u * 4 + a * 5 + e * 5 + transportFee + beforeCost + afterCost + handling;
      field('aromatic-row').hidden = market !== 'nyc';
      field('expression-row').hidden = market !== 'la';
      field('expression-total-row').hidden = e === 0;
      field('expression-breakage').hidden = market !== 'la';
      field('expression-breakage-text').hidden = market !== 'la';
      field('grand-label').textContent = 'Estimated subtotal';
      field('delivery-details').hidden = pickup;
      field('pickup-note').hidden = !pickup;
      field('pickup-note').textContent = `Pickup and return are in ${pickupLocation}. We'll confirm the exact address and hours with you.`;
      field('zip').required = !pickup;
      field('zip-star').hidden = pickup;
      field('arrival-label').textContent = pickup ? 'Pickup date *' : 'Delivery date *';
      field('return-label').textContent = pickup ? 'Return date *' : 'Collection date *';
      field('arrival-hint').textContent = pickup ? 'Pickup must be at least one day before your event. We suggest the preceding weekday.' : 'Delivery must be at least one day before your event. We suggest the preceding weekday.';
      field('return-hint').textContent = pickup ? 'Suggested: the weekday after your event.' : 'Suggested: the weekday after your event.';
      field('transport-label').textContent = pickup ? `Pickup & return · ${pickupLocation}` : 'Delivery & collection';
      field('transport-fee').textContent = money(transportFee);
      field('transport-note').textContent = pickup ? `Pickup and return are in ${pickupLocation}. Pickup must be at least one day before the event. The $50 fee covers customer pickup and return. We will confirm the exact address, hours, and availability. Taxes and breakage are additional where applicable.` : 'Delivery must be at least one day before the event. The $300 round-trip delivery fee assumes a nearby address and standard weekday service. We will confirm the actual charge and dates after reviewing your location. Taxes, unusual access, and breakage are additional where applicable.';
      field('before-term').textContent = before === 'self' ? 'Glasses may arrive unwashed or dirty. You agree to wash and polish them before use.' : `You requested ${before === 'polish' ? 'wash and polish' : 'washing'} before the event. This service must be confirmed before booking.`;
      field('after-term').textContent = after === 'self' ? (pickup ? 'You agree to wash the glasses after the event. Unwashed glasses will not be accepted when you return them.' : 'You agree to wash the glasses after the event. We will not collect unwashed glasses.') : 'You requested partner washing after the event. This service and collection or return arrangements must be confirmed before booking.';
      field('breakage-term').textContent = `You agree to $20 per broken or missing Universal stem and $25 per broken or missing Aromatic stem.${market === 'la' ? ' You agree to $22.50 per broken or missing Expression stem.' : ''}`;
      field('terms-checkbox').value = `Yes — ${field('before-term').textContent} ${field('after-term').textContent} ${field('breakage-term').textContent}`;
      field('u-count').textContent = u;
      field('a-count').textContent = a;
      field('e-count').textContent = e;
      field('u-total').textContent = money(u * 4);
      field('a-total').textContent = money(a * 5);
      field('e-total').textContent = money(e * 5);
      field('before-total').textContent = money(beforeCost);
      field('after-total').textContent = money(afterCost);
      field('before-handling-row').hidden = !beforeHandling;
      field('after-handling-row').hidden = !afterHandling;
      field('grand').textContent = money(total);
      field('minimum-note').hidden = stems === 0 || stems >= 125;
      const beforeLabel = field('before').selectedOptions[0].textContent.trim();
      const afterLabel = field('after').selectedOptions[0].textContent.trim();
      const summary = `Market: ${field('market').selectedOptions[0].textContent.trim()}; Universal: ${u} × $4 = ${money(u * 4)}; Aromatic: ${a} × $5 = ${money(a * 5)}; Expression: ${e} × $5 = ${money(e * 5)}; ${pickup ? `customer pickup/return in ${pickupLocation}` : 'delivery/collection'}: ${money(transportFee)}; pre-event care: ${money(beforeCost)}; before-event handling: ${money(beforeHandling)}; post-event care: ${money(afterCost)}; after-event handling: ${money(afterHandling)}; NY/NJ sales tax (if applicable): calculated in final quote; estimated subtotal before tax: ${money(total)}.`;
      field('estimate').value = summary;
      field('quantities').value = `${u} Universal; ${a} Aromatic; ${e} Expression; ${stems} total stems`;
      field('cleaning-summary').value = `${beforeLabel}; ${afterLabel}. All stems must be washed before use and after use. If customer handles return wash, stems must be returned washed.`;
      field('body').value = `Glasvin rental quote request\n${summary}\nEvent: ${field('event').value || '—'}; requested ${pickup ? 'pickup' : 'delivery'}: ${field('delivery').value || '—'}; requested ${pickup ? 'return' : 'collection'}: ${field('collection').value || '—'}.\nCleaning: ${field('cleaning-summary').value}\nFee and dates subject to availability and logistics confirmation. Breakage: $20/Universal stem, $25/Aromatic stem, $22.50/Expression stem. Taxes and breakage additional where applicable.`;
    }
    ['universal', 'aromatic', 'expression', 'before', 'after', 'transport'].forEach(key => field(key).addEventListener('input', () => {
      if (['before', 'after', 'transport'].includes(key)) field('terms-checkbox').checked = false;
      update();
    }));
    field('market').addEventListener('change', () => {
      if (field('market').value !== 'nyc') field('aromatic').value = '0';
      if (field('market').value !== 'la') field('expression').value = '0';
      field('terms-checkbox').checked = false;
      update();
    });
    form.addEventListener('submit', event => {
      update();
      const stems = quantity('universal') + (field('market').value === 'nyc' ? quantity('aromatic') : 0) + (field('market').value === 'la' ? quantity('expression') : 0);
      const eventDate = parseDate(field('event').value);
      const delivery = parseDate(field('delivery').value);
      const collection = parseDate(field('collection').value);
      const pickup = field('transport').value === 'pickup';
      const issue = !stems ? 'Enter at least one glass.' : !eventDate || !delivery || !collection ? 'Select the event, handoff, and return dates.' : delivery >= eventDate ? `${pickup ? 'Pickup' : 'Delivery'} must be at least one day before your event.` : collection <= eventDate ? `${pickup ? 'Return' : 'Collection'} must be after your event.` : '';
      field('validation').textContent = issue;
      field('validation').hidden = !issue;
      if (issue) { event.preventDefault(); field('validation').scrollIntoView({ block: 'center', behavior: 'smooth' }); }
    });
    update();
  });

  } catch(e) { console.error(e); }
})();
})();
